export const SKYSCAPE_BASKET_ERROR_CODES = ['fast_selling_item_sold_out', 'max_quantity_exceeded'];

export const DEFAULT_BASKET_ERROR_MESSAGE =
  'There has been a technical issue. Please reload the page and try again or try again later.';
